import { PropsWithChildren, useRef } from 'react';
import { useGSAP } from '@gsap/react';
import gsap from 'gsap';

type Props = PropsWithChildren<{
  className?: string;
  /** GSAP ScrollTrigger start string */
  start?: string;
}>;

/** Fade/slide sections into view on scroll. */
export default function RevealSection({ children, className, start = 'top 88%' }: Props) {
  const root = useRef<HTMLDivElement | null>(null);

  useGSAP(
    () => {
      if (!root.current) return;
      gsap.from(root.current, {
        opacity: 0,
        y: 32,
        duration: 0.75,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: root.current,
          start,
          toggleActions: 'play none none none',
        },
      });
    },
    { scope: root },
  );

  return (
    <div ref={root} className={className}>
      {children}
    </div>
  );
}
